<template>
  <div class="article-view-wrapper" :style="$vuetify.breakpoint.smAndDown ? 'padding: 5%' : ''">
    <!-- Article Title -->
    <div class="article-block">
      <TitleBlock :title="article.title" :has_permission_edit="false" :editing="false"
        :block_id="'title-block'" />
    </div>

    <div class="article-line article-head-space" />
    <!-- Author, Published Date -->
    <div class="article-subheader">
      <h2 class="left" v-if="authors" :style="$vuetify.breakpoint.smAndDown ? 'font-size: 9pt' : ''" v-html="authors" />
      <h3 class="right" :style="$vuetify.breakpoint.smAndDown ? 'font-size: 11pt' : ''">
        {{ getArticleDate(article) }}
      </h3>
    </div>
    <!-- Actual Content -->
    <div v-for="(block, i) in article.blocks" :key="`article-block${i + 1}`" class="article-space">
      <div class="article-block">
        <!-- Texte -->
        <TextBlock v-if="block.type === 'textblocks'" :textblock="block"
          :has_permission_edit="false" :editing="false"
          :block_id="`text-block${block.id}`" :is_selected="current_block === `text-block${block.id}`" />
        <!-- Images, Videos, etc. -->
        <MediaBlock v-else :mediablock="block"
          :editing="false" :has_permission_edit="false"
          :block_id="`media-block${block.id}`" :is_selected="current_block === `media-block${block.id}`" />
      </div>
    </div>
    <div class="article-space">
      <div class="article-hashtag-container article-block">
        <div v-for="(hashtag, i) in hashtags" :key='`hashtag${i}`'>
          <Hashtag :hashtag="hashtag" :has_permission_edit="false" :is_template="hashtag.is_template"
            :is_show_error="is_show_hashtag_error" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBlock from '@/components/Articles/TitleBlock.component.vue';
import TextBlock from '@/components/Articles/TextBlock.component.vue';
import MediaBlock from '@/components/Articles/MediaBlock.component.vue';
import Hashtag from '@/components/Articles/Hashtag.component.vue';

export default {
  components: {
    TitleBlock,
    TextBlock,
    MediaBlock,
    Hashtag,
  },
  props: [
  ],
  data: () => ({
    current_block: '',
    is_show_hashtag_error: false,
    article: {
      id: 0,
      title: 'General Information',
      authors: [
        {"id":1,"first_name":"Raphael","last_name":"Hippe"},
        {"id":2,"first_name":"Clemens","last_name":"Basler"},
        {"id":3,"first_name":"Philipp","last_name":"Basler"}
      ],
      publish_date: "2022-12-08 14:51:01 UTC",
      blocks: [
        {
          id: 3,
          type: 'textblocks',
          text: "<p>Seit mehr als 2 Jahren entwickeln und betreiben wir eine webbasierte Plattform für Produktionsprozesse in Bauprojekten. Die Baubranche steckt beim Thema  Digitalisierung und Softwarelösungen   noch in den Kinderschuhen. Daher besteht hier die besondere Herausforderung und Möglichkeit, neue und innovative Standards zu setzen und somit eine der größten Industrien der Welt zu revolutionieren. Mit einigen unserer internationalen Kunden arbeiten wir eng zusammen, um zu garantieren, dass die entwickelten Feature auch praxisrelevant sind. </p>"
        },
        {
          id: 4,
          type: 'textblocks',
          text: "<p>Unser Kernteam besteht aktuell aus fünf Personen: Zwei Informatik Absolventen der HKA, primär zuständig für unser Backend und die Server-Infrastruktur, einem Bauingenieur, umgelernt und zuständig für Frontend-Entwicklung, sowie zwei als Product Owner agierenden Ingenieuren. Beide sind in leitenden Positionen in der Baubranche tätig und haben über unser Kernthema erfolgreich promoviert. Des Weiteren werden wir durch tatkräftige Studenten von KIT und HKA unterstützt.</p>"
        },
        {
          id: 1,
          type: 'textblocks',
          text: "<p>Der genereller Ablauf zum Einstieg in die Firma sieht, bei uns, wie folgt aus: Du schaust bei uns auf dem Discord vorbei und schreibst woran du interessiert bist. Danach machen wir zeitnah ein Termin zum Kennenlernen aus. Wenn wir uns dann einig sind lernst du (meistens per Telefon) den Rest unseres Kernteams kennen. Danach kann es auch schon los gehen!</p>"
        },
        {
          id: 2,
          type: 'textblocks',
          text: "<p>Unsere Stellenausschreibungen geben Dir eine Idee, wonach wir aktuell suchen. Falls Du dort kein Thema findest, was Dich anspricht und Du Dich trotzdem für uns interessiert schau einfach trotzdem bei uns auf dem Discord vorbei.</p>"
        },
      ]
    }
  }),
  computed: {
    hashtags() {
      let arr = [];
      if(!this.article.hashtags) {
        return arr;
      }

      for(let i = 0; i < this.article.hashtags.length; i++) {
        arr.push(this.article.hashtags[i])
      }

      return arr;
    },

    authors() {
      let s = '<span>';
      if(this.article.authors.length >= 1) {
        s += 'Ansprechpartner: ';
        s += `<span class="author-name">${ this.article.authors[0].first_name } ${ this.article.authors[0].last_name }</span>`;
      }

      for(let i = 1; i < this.article.authors.length; i++) {
        s += `, <span class="author-name">${ this.article.authors[i].first_name } ${ this.article.authors[i].last_name }</span>`;
      }
      s += '</span>'
      return s;
    },

  },
  methods: {
    getArticleDate(article) {
      if(article.published == 'public') {
        return this.formatDate(article.publish_date);
      }

      return this.date_today;
    },
  }
}
</script>
<style scoped>
.article-view-wrapper {
  padding: 0 10%;
}
.article-block {
  position: relative; /* for editBtn */
}
.article-line {
  border-style: solid;
  border-color: white;
  border-width: 0 0 1px 0;
}
.article-head-space {
  margin: 30px 0 20px 0;
}
.article-subheader {
  display: flex;
  flex-direction: row;
}
.article-hashtag-container {
  display: flex;
  grid-column-gap: calc(var(--grid-space) * 1px);;
  grid-row-gap: calc(var(--grid-space) * 1px);;
  justify-content: center;
  flex-wrap: wrap;
}
h2, .author-name {
  font-weight: 300;
  font-size: 12pt;
  font-style: italic;
  width: 50%;
}
h3 {
  font-weight: 300;
  font-size: 14pt;
  width: 50%;
}
.right {
  text-align: right;
}
.left {
  text-align: left;
}
</style>